// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://mynestapi.happynest.live/',
  // apiUrl: 'https://CustomerPortalAPI.4sightview.com/',
  //  apiUrl: 'http://localhost:53321/',
  captchaKey: '6LfBdnkUAAAAAFB8kCahrrFifMqvHUaLIbQWrHbF',
  PaymentUrl:
    'https://test.ccavenue.com/transaction.do?command=initiateTransaction',
  // crmApiUrl: 'http://localhost:57009/'
  crmApiUrl: 'https://crmapi.happynest.live/'
  // crmApiUrl: 'https://CRMPortalAPI.4sightview.com/api/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
